import {GwtConfig} from 'OK/GwtConfig';
import {ApplicationBannerCfgJs, IApplicationBannerCfgData} from 'OK/banners/bannerNew/config/ApplicationBannerCfgJs';
import {BannerMultiloadCfgJs, IBannerMultiloadCfgData} from 'OK/banners/bannerNew/config/BannerMultiloadCfgJs';
import {BannerRefreshPolicyCfgJs} from 'OK/banners/bannerNew/config/BannerRefreshPolicyCfgJs';

let instance: BannerCfgJs;

export interface IBannerCfgData {
    lastApps: string;
    applicationBannerSlots: IApplicationBannerCfgData;
    adm: IBannerMultiloadCfgData;
    timeouts: Record<string, number>;
    expr: string;
    vha_debug: boolean;
    dre: boolean;
    ce: boolean;
}

export class BannerCfgJs extends GwtConfig<IBannerCfgData> {
    lastApplications!: string;
    applicationBannerCfg!: ApplicationBannerCfgJs;
    multiLoad!: BannerMultiloadCfgJs;
    timeoutCfg!: BannerRefreshPolicyCfgJs;
    expr: string | null = null;
    vhaBannerDebug: boolean = false;
    discussionsRefreshEnabled: boolean = false;
    callbacksEnabled: boolean = false;

    constructor() {
        super('BannerConfig');
    }

    setData(data: IBannerCfgData) {
        super.setData(data);

        this.lastApplications = this.data.lastApps;
        this.applicationBannerCfg = new ApplicationBannerCfgJs(this.data.applicationBannerSlots || {});
        this.multiLoad = new BannerMultiloadCfgJs(this.data.adm || {});
        this.timeoutCfg = new BannerRefreshPolicyCfgJs(this.data.timeouts);
        this.expr = this.data.expr || null;
        this.vhaBannerDebug = this.data.vha_debug || false;
        this.discussionsRefreshEnabled = this.data.dre || false;
        this.callbacksEnabled = this.data.ce || false;
    }

    getApplicationBannerCfg(): ApplicationBannerCfgJs {
        return this.applicationBannerCfg;
    }

    static getInstance(): BannerCfgJs {
        if (!instance) {
            instance = new BannerCfgJs();
        }
        return instance;
    }

    static getLastApplications(): string | null {
        try {
            return BannerCfgJs.getInstance().lastApplications;
        } catch (e) {
            return null;
        }
    }

    static getMultiLoad(): BannerMultiloadCfgJs | null {
        try {
            return BannerCfgJs.getInstance().multiLoad;
        } catch (ex) {
            return new BannerMultiloadCfgJs({});
        }
    }

    static getRefreshPolicyCfg(): BannerRefreshPolicyCfgJs {
        try {
            return BannerCfgJs.getInstance().timeoutCfg;
        } catch (ex) {
            return new BannerRefreshPolicyCfgJs({});
        }
    }

    static getCurrentExperiment(): string | null {
        try {
            return BannerCfgJs.getInstance().expr;
        } catch (ex) {
            return null;
        }
    }
}
